import type { LimitOrderPlacementRequest } from 'apiConnector/secondary-market/limit-order/models';
import { limitOrderInputFormSelectors } from 'state/secondaryMarket/limit-order/form/input/inputForm.selectors';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { limitOrderOrderActions } from 'state/secondaryMarket/limit-order/order/order.action';
import { limitOrderReferentialSelectors } from 'state/secondaryMarket/limit-order/referential/referential.selector';
import { fromSecondaryQuotesWorkspace } from 'state/selectors';
import type { Thunk } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';
import { workspaceTabSetBusy } from 'state/workspaces/workspace.actions';
import { getTabWorkspaceType } from 'state/workspaces/workspaces/workspaces.selector';

function getOrderRequest(state: AppState, tabId: string): LimitOrderPlacementRequest {
  const client = limitOrderSelectors.getFormClient(state, tabId);
  const tradeSizeInputMode = limitOrderInputFormSelectors.getFormTradeSizeInputMode(state, tabId);

  return {
    productKey: fromSecondaryQuotesWorkspace.getProductKey(state, tabId),
    cashAmount: tradeSizeInputMode === 'amount' ? limitOrderSelectors.getFormCashAmount(state, tabId) : undefined,
    comment: limitOrderInputFormSelectors.getFormComment(state, tabId),
    priceType: limitOrderReferentialSelectors.getPriceType(state, tabId),
    clientLimit: limitOrderInputFormSelectors.getLimit(state, tabId),
    salesMarginAdjustment: limitOrderInputFormSelectors.getSalesMarginAdjustment(state, tabId),
    clientType: limitOrderSelectors.getFormClientType(state, tabId),
    clientBdrId: client?.id,
    clientEliotCode: client?.eliotCode,
    fileCode: limitOrderReferentialSelectors.getFileCode(state, tabId),
    quantity:
      tradeSizeInputMode === 'quantity' ? limitOrderInputFormSelectors.getFormQuantity(state, tabId) : undefined,
    salesId: limitOrderSelectors.getFormSalesId(state, tabId),
    custodianBdrId: limitOrderSelectors.getFormCustodianBdrId(state, tabId),
    settlementDate: limitOrderSelectors.getFormSettlementDate(state, tabId),
    settlementType: limitOrderSelectors.getFormSettlement(state, tabId),
    way: limitOrderSelectors.getFormTradeWay(state, tabId),
  };
}

export function secondaryMarketLimitOrderOrderRequestedThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const request = getOrderRequest(state, tabId);
    const workspaceType = getTabWorkspaceType(state, tabId)!;
    dispatch(
      limitOrderOrderActions.secondaryMarketOrderPlacementRequested(
        tabId,
        workspaceType as SecondaryWorkspaceType,
        request,
      ),
    );
    dispatch(workspaceTabSetBusy(tabId, workspaceType!, true));
  };
}
